module.exports = __webpack_public_path__ + "img/popup_first_pay_select.828a70b0.png";